<template>
  <div class="container_PDropDownContainer">
    <div class="overlay" v-if="isOpen && !alwaysOpen" @click="open" />
    <div ref="button" @click="open">
      <div>
        <slot name="content"></slot>
      </div>
    </div>
    <div ref="dropdown" :class="classOptions" v-show="isOpen">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import Popper, { Placement } from "popper.js";

@Component
export class PDropDownContainer extends Vue {
  @Prop({ required: false, default: false }) value!: boolean;
  @Watch("value")
  onChangeShow(): void {
    this.isOpen = this.value;
  }
  @Prop({ required: false, default: false }) alwaysOpen!: boolean;
  @Prop({ required: false, default: false }) alwaysClose!: boolean;
  @Ref("button") readonly button!: any;
  @Ref("dropdown") readonly dropdown!: any;
  @Prop({ required: false, default: "bottom-start" }) placement!: Placement;
  popper: any = undefined;
  isOpen = false;
  get classOptions(): string {
    if (this.alwaysOpen) {
      return "alwaysOpen_PDropDownContainer";
    } else {
      return "optionsSelect_PDropDownContainer";
    }
  }
  beforeDestroy(): void {
    if (this.popper) this.popper.destroy();
  }
  mounted(): void {
    if (this.alwaysOpen) {
      this.isOpen = true;
    }
  }

  setupPopper(): void {
    // this.popper var is not reactive because it is not into data()
    // we use for save the instanciate new Popper once and avoid memory leaks using always this.popper
    if (this.popper === undefined) {
      this.popper = new Popper(this.button, this.dropdown, {
        placement: this.placement,
      });
    } else {
      // recalculate
      this.popper.scheduleUpdate();
    }
  }

  open(): void {
    if (!this.alwaysClose) {
      this.isOpen = !this.isOpen;
      this.$emit("input", this.isOpen);
      // Wait to nextTick due to searchInput focus() it's not already mounted ( v-show )
      if (this.popper) this.setupPopper();
      this.$nextTick(() => {
        this.setupPopper();
      });
    } else if (this.popper) {
      this.popper.destroy();
    }
  }
}
export default PDropDownContainer;
</script>
<style lang="scss" scoped>
.container_PDropDownContainer {
  position: relative;
}
.containerDatePiker .optionsSelect_PDropDownContainer {
  width: 360px;
  min-width: inherit;
}
.optionsSelect_PDropDownContainer {
  position: absolute;
  z-index: 5;
  min-width: 100%;
  border-radius: 6px;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.12);
  border: solid 0.7px #dcdcdc;
  background-color: #fff;
}
.alwaysOpen_PDropDownContainer {
  min-width: 100%;
  border-radius: 6px;
  border: solid 0.7px #dcdcdc;
  background-color: #fff;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
</style>
